/**
 * @fileoverview Provide a shared loading signifier for workspaces that own the pending operation. The component has no knowledge of request identity, progress, or completion; callers decide when it appears and provide surrounding workflow context.
 */

import React from 'react'
import './AppSpinner.css'



function AppSpinner({ style, className = '', strokeWidth, animationDuration, ...props }) {
    return <div {...props} className={`app-spinner ${className}`} style={style} role="status" aria-label="Loading" />
}

export default AppSpinner

export { AppSpinner as ProgressSpinner };
